import { registerLocaleData } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import ngLang from '@angular/common/locales/en';
import localeEnMy from '@angular/common/locales/en-MY';
import { APP_INITIALIZER, LOCALE_ID, NgModule, isDevMode } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ServiceWorkerModule } from '@angular/service-worker';
import { DefaultInterceptor } from '@core';
import { en_US as delonLang } from '@delon/theme';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { enUS as dateLang } from 'date-fns/locale';
import { en_US as zorroLang } from 'ng-zorro-antd/i18n';
import { QuillModule } from 'ngx-quill';

import { appConfig } from './app.config';
import { CoreModule } from './core/core.module';
import { LayoutModule } from './layout/layout.module';
import { metaReducers, reducers } from './reducers';
import { RoutesModule } from './routes/routes.module';
import { SharedModule } from './shared/shared.module';
import { DevExtremeConfigService } from './shared/services/devextreme-config.service';
import { environment } from '../environments/environment'; // Angular CLI environment

function initDevExtreme(devExtremeConfig: DevExtremeConfigService): () => void {
  return () => {
    devExtremeConfig.configureDevExtreme();
  };
}

// #region default language
// Reference: https://ng-alain.com/docs/i18n
const LANG = {
  abbr: 'en',
  ng: ngLang,
  zorro: zorroLang,
  date: dateLang,
  delon: delonLang
};

// registerLocaleData(LANG.ng, LANG.abbr);
// const LANG_PROVIDES = [
//   { provide: LOCALE_ID, useValue: LANG.abbr },
//   { provide: NZ_I18N, useValue: LANG.zorro },
//   { provide: NZ_DATE_LOCALE, useValue: LANG.date },
//   { provide: DELON_LOCALE, useValue: LANG.delon }
// ];
// #endregion

// import { JWTInterceptor } from '@delon/auth';
const INTERCEPTOR_PROVIDES = [
  // { provide: HTTP_INTERCEPTORS, useClass: JWTInterceptor, multi: true },
  { provide: HTTP_INTERCEPTORS, useClass: DefaultInterceptor, multi: true }
];
// #endregion

registerLocaleData(localeEnMy, 'en-MY');

@NgModule({
  declarations: [],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    CoreModule,
    SharedModule,
    LayoutModule,
    RoutesModule,
    QuillModule.forRoot({
      suppressGlobalRegisterWarning: true,
      modules: {
        toolbar: [
          [{ size: ['small', false, 'large', 'huge'] }], // custom dropdown
          [
            {
              font: [
                'Arial',
                'Courier New',
                'Georgia',
                'Impact',
                'Lucida Console',
                'Tahoma',
                'Times New Roman',
                'Verdana'
              ]
            }
          ],
          ['bold', 'italic', 'underline', 'strike'], // toggled buttons
          ['blockquote', 'code-block'],

          [{ list: 'ordered' }, { list: 'bullet' }],
          //[{ 'script': 'sub'}, { 'script': 'super' }],      // superscript/subscript
          [{ indent: '-1' }, { indent: '+1' }], // outdent/indent

          //[{ 'header': [1, 2, 3, 4, 5, 6, false] }],

          [{ color: [] }, { background: [] }], // dropdown with defaults from theme
          //[{ 'font': [] }],
          [{ align: [] }],

          ['clean'] // remove formatting button

          //['link']                         // link and image, video
        ]
      }
    }),
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: !isDevMode(),
      // Register the ServiceWorker as soon as the application is stable
      // or after 30 seconds (whichever comes first).
      registrationStrategy: 'registerWhenStable:30000'
    }),
    StoreModule.forRoot(reducers, { metaReducers }),
    EffectsModule.forRoot([]),
    !environment.production ? StoreDevtoolsModule.instrument() : []
  ],
  providers: [
    //...LANG_PROVIDES,
    { provide: LOCALE_ID, useValue: 'en-MY' },
    ...INTERCEPTOR_PROVIDES,
    ...appConfig.providers,
    { provide: 'BASE_URL', useValue: environment.api.baseUrl },
    {
      provide: APP_INITIALIZER,
      useFactory: initDevExtreme,
      deps: [DevExtremeConfigService],
      multi: true
    }
  ]
})
export class AppModule {
  constructor() {
    registerLocaleData(LANG.ng, LANG.abbr);
  }
}
